import React from 'react';

import { DropdownButton, DropdownContainer, DropdownContent } from './UI';

const Dropdown = ({ buttonContent, dropdownContent, open, setOpen }) => {
  const dropdownButtonRef = React.useRef(null);
  const dropdownContentRef = React.useRef(null);

  const toggleOpen = React.useCallback(() => {
    setOpen(!open);
  }, [open, setOpen]);

  React.useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (dropdownContentRef.current == null) {
        return;
      }

      if (!dropdownContentRef.current.contains(event.target) &&
          !dropdownButtonRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, setOpen]);

  return (
    <DropdownContainer>
      <DropdownButton type="button" onClick={toggleOpen} ref={dropdownButtonRef}>
        {buttonContent}
      </DropdownButton>

      {open && (
        <DropdownContent ref={dropdownContentRef}>
          {dropdownContent}
        </DropdownContent>
      )}
    </DropdownContainer>
  );
};

export default Dropdown;
